import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LanguageSelector = ({ currentLanguage, onLanguageChange, availableLanguages }) => {
  const languages = availableLanguages || [
    { code: 'en', name: 'English', flag: '🇺🇸', region: 'Global' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪', region: 'Deutschland' },
    { code: 'fr', name: 'Français', flag: '🇫🇷', region: 'France' },
    { code: 'es', name: 'Español', flag: '🇪🇸', region: 'España' }
  ];

  return (
    <div className="bg-card border border-border rounded-brand p-4">
      <div className="flex items-center space-x-3 mb-4">
        <div className="p-2 bg-primary/10 rounded-brand-sm">
          <Icon name="Globe" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="font-semibold text-foreground">Language & Region</h3>
          <p className="text-sm text-muted-foreground">Select your preferred language for legal documents</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {languages?.map((language) => (
          <Button
            key={language?.code}
            variant={currentLanguage === language?.code ? "default" : "outline"}
            className={`justify-start h-auto p-3 ${
              currentLanguage === language?.code 
                ? 'bg-primary text-primary-foreground border-primary' 
                : 'hover:border-primary/50'
            }`}
            onClick={() => onLanguageChange(language?.code)}
          >
            <div className="flex items-center space-x-3 w-full">
              <span className="text-lg">{language?.flag}</span>
              <div className="text-left">
                <div className="font-medium">{language?.name}</div>
                <div className={`text-xs ${
                  currentLanguage === language?.code 
                    ? 'text-primary-foreground/80' 
                    : 'text-muted-foreground'
                }`}>
                  {language?.region}
                </div>
              </div>
              {currentLanguage === language?.code && (
                <Icon name="Check" size={16} className="ml-auto" />
              )}
            </div>
          </Button>
        ))}
      </div>
      <div className="mt-4 p-3 bg-muted rounded-brand-sm">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} className="text-primary mt-0.5" />
          <div className="text-sm">
            <p className="text-foreground font-medium mb-1">Legal Compliance Notice</p>
            <p className="text-muted-foreground">
              Documents are localized according to regional legal requirements and GDPR compliance standards.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;